import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from '..';
import {
  GetLanguagesResponseShape,
  RolesResponseShape,
  UserShape,
  UsersResponseShape,
} from 'models/users';

export const UsersApi = createApi({
  reducerPath: 'usersApi',
  tagTypes: ['Users', 'UserDetails'],
  baseQuery,
  endpoints: (builder) => ({
    getTableData: builder.query<UsersResponseShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['Users'],
    }),
    getRolesData: builder.query<RolesResponseShape, string>({
      query: (url) => ({
        url: url,
      }),
    }),
    getUserById: builder.query<UserShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['UserDetails'],
    }),

    deleteUserByID: builder.mutation<UserShape, string>({
      query: (url) => ({
        url: url,
        method: 'DELETE',
      }),
    }),
    unAssignAllTp: builder.mutation<UserShape, string>({
      query: (url) => ({
        url: url,
        method: 'POST',
      }),
      invalidatesTags: ['Users'],
    }),
    getLanguages: builder.query<GetLanguagesResponseShape, string>({
      query: (url) => ({
        url: url,
      }),
    }),
  }),
});

export const {
  useGetTableDataQuery,
  useGetRolesDataQuery,
  useGetUserByIdQuery,
  useDeleteUserByIDMutation,
  useUnAssignAllTpMutation,
  useGetLanguagesQuery,
} = UsersApi;
